import Styles from "./styles.module.scss";
import Logo from "../../assets/Logo.svg";
import LogoAffiniwatch from "../../assets/affiniwatch-logo.png";
import { useAppBarTitle } from "./Title/context";
import { useTheme } from "../../routes/gestion-sav/Theme/useTheme";
import { ReactNode } from "react";

export default function Appbar({
  onPressOpenMenu = () => null,
  onPressChangeMenuSize = () => null,
  backButton = null
}: {
  onPressChangeMenuSize?: () => any;
  onPressOpenMenu?: () => any;
  backButton?: ReactNode;
}) {

  const { title } = useAppBarTitle();
  const theme = useTheme();
  return (
    <>
      <div className={Styles.container} style={{ zIndex: 1 }}>
        <div className={Styles.logoContainer}>
          <img src={theme === "affinicar" ? Logo : LogoAffiniwatch} />
        </div>

        <div className={Styles.openMenuButtonContainer}>
          <button type="button" className="btn btn-transparent" onClick={onPressOpenMenu}>
              <i className="fa-solid fa-bars-staggered text-primary fs-5"></i>
          </button>
        </div>

        <div className={Styles.changeMenuSizeButtonContainer}>
          <button type="button" id="sidebarLeftCollapse" className="btn btn-transparent" onClick={onPressChangeMenuSize}>
              <i className="fa-solid fa-bars-staggered text-primary fs-5"></i>
          </button>
        </div>

        {backButton && (
        <div className={"tw-flex tw-flex-row tw-gap-2 tw-pl-2"}>
          {backButton}
        </div>
        )}

        <h1 className={Styles.title}>{title}</h1>
      </div>

    </>
  )
}